// extracted by mini-css-extract-plugin
export default {"root":"AddBank_root__Vp_76","add":"AddBank_add__14jT1","arrow":"AddBank_arrow__1QPJk","content":"AddBank_content__2_7hI"};